import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'Low-Latency',
  attributeName: 'lowLatency',
  fields: [
    {
      attributeName: 'numberOfRtmpPlayers',
      label: 'Number Of RTMP Players',
      default: '2',
      type: FormInputTypes.SELECT,
      helpText: 'How the player change is done in the app.',
      options: [
        { name: 'Always use one player', value: '1' },
        { name: 'Always one enabled player and one disabled player', value: '2' },
      ],
    },
    {
      attributeName: 'speedAdjustmentEnabled',
      helpText: 'Whether the speed adjustment is enabled for RTMP or not (defaul = true).',
      type: FormInputTypes.CHECKBOX,
      label: 'Speed Adjustment Enabled',
      default: true,
    },
    {
      attributeName: 'numberOfFramesToBeStable',
      helpText: 'Number of frames to exit from the buffer to consider that the playback is advancing.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Number Of Frames To Be Stable',
      placeholder: 'Input the Number Of Frames To Be Stable...',
      default: 0,
    },
    {
      attributeName: 'numberOfUpdatesForPlaybackToBeStable',
      helpText: 'Number of consecutive updates that the playback speed should be one to be considered stable.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Number Of Updates For Playback To Be Stable',
      placeholder: 'Input the Number Of Updates For Playback To Be Stable...',
      default: 0,
    },
    {
      attributeName: 'enterTheVideoTimeOut',
      helpText: 'Time out for the app to decide to go home after failing at open a video.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Enter The Video TimeOut',
      placeholder: 'Input the Enter The Video TimeOut...',
      default: 0,
    },
    {
      attributeName: 'cameraChangeTimeOut',
      helpText: 'Time out for the app to decide to cancel the camera change that is not happening.',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Camera Change TimeOut',
      placeholder: 'Input the Camera Change TimeOut...',
      default: 0,
    },
  ],
};
